import * as i from 'types';

export const findBusesComparingTool = (vans: i.Car[], answers: Required<i.DecisionAidAnswers>): i.ComparedCar[] => {
  const addPointsToScore = (van: i.ComparedCar, category: Exclude<i.DecisionAidIds, 'mostImportantFactor'>) =>  {
    const points = category === answers.mostImportantFactor ? 3 : 1;
    return { ...van, comparedScore: van.comparedScore + points };
  };

  const checkPrice = (van: i.ComparedCar, price: string) => {
    return van.price <= parseInt(price) ? addPointsToScore(van, 'price') : van;
  };

  const checkSize = (van: i.ComparedCar, size: string) => {
    return van.size === size ? addPointsToScore(van, 'size') : van;
  };

  const checkActionRadius = (van: i.ComparedCar, actionRadius: string) => {
    return parseInt(van.actionRadius) >= parseInt(actionRadius) ? addPointsToScore(van, 'actionRadius') : van;
  };

  const checkTrailerCapacity = (van: i.ComparedCar, trailerCapacity: string) => {
    return (van.trailerCapacity >= parseInt(trailerCapacity)) || trailerCapacity === 'nee' ? addPointsToScore(van, 'trailerCapacity') : van;
  };

  const checkLoadingCapacity = (van: i.ComparedCar, loadingCapacity: string) => {
    return (van.loadingCapacity >= parseInt(loadingCapacity)) ? addPointsToScore(van, 'loadingCapacity') : van;
  };

  const checkUsage = (van: i.ComparedCar, usages: (keyof i.UsageType)[]) => {
    const vanUsages = Object.keys(van.usage).filter((key) => van.usage[key as keyof i.UsageType]);
    const meetsAllUsageRequirements = usages.every((usage) => vanUsages.includes(usage));
    return meetsAllUsageRequirements ? addPointsToScore(van, 'usage') : van;
  };

  const comparedVans = vans.map((van) => {
    const comparedVan = { ...van, comparedScore: 0 };
    const checkedPrice = checkPrice(comparedVan, answers.price);
    const checkedSize = checkSize(checkedPrice, answers.size);
    const checkedActionRadius = checkActionRadius(checkedSize, answers.actionRadius);
    const checkedTrailerCapacity = checkTrailerCapacity(checkedActionRadius, answers.trailerCapacity);
    const checkedLoadingCapacity = checkLoadingCapacity(checkedTrailerCapacity, answers.loadingCapacity);
    return checkUsage(checkedLoadingCapacity, answers.usage);
  });

  // order vans by best score and return best 3
  return comparedVans.sort((a, b) => b.comparedScore - a.comparedScore).slice(0, 3);
};
